import React from 'react';
import { makeStyles } from '@material-ui/core';
import { formatDistance } from '../../../../../../utils';
import { COLOR_BLACK, COLOR_WHITE } from '../../../../../colors';
import FEATURE_CONFIG from '../feature-config';
import AreaIcon from '../AreaIcon';

const useFeatureStyles = makeStyles((theme)=> ({
    relativeDiv: {
        position: 'relative',
        width: '100%',
        height: '100%',
        textAlign: 'center',
    },
    featureBlock: {
        position: 'absolute',
        width: 104,
        height: 172,
    },
    featurePosition1: {
        top: 0,
        left: 233,
    },
    featurePosition2: {
        top: 0,
        left: 367,
    },
    featurePosition3: {
        top: 184,
        left: 367,
    },
    featurePosition4: {
        top: 184,
        left: 233,
    },
    featurePosition5: {
        top: 184,
        left: 99,
    },
    featurePosition6: {
        top: 368,
        left: 99,
    },
    distance: {
        fontSize: 14,
        lineHeight: '20px',
    },
    label: {
        fontSize: 16,
        lineHeight: '19px',
        fontWeight: 600,
    },
    iconBubble: {
        width: 104,
        height: 104,
        backgroundColor: COLOR_WHITE,
        boxSizing: 'border-box',
        border: `4px solid ${COLOR_BLACK}`,
        borderRadius: 52,
        paddingTop: '52.5%',
        marginBottom: 8,
    },
    icon: {
        transform: 'translate(0, -52.5%)',
        fontSize: '3rem',
    }
}));


const useAnimationStyles = makeStyles((theme)=> ({
    iconBubble: {
        backgroundColor: COLOR_BLACK,
        color: COLOR_WHITE,
    },

    icon: {
        color: COLOR_WHITE,
    }
}));

function AreaFeature({ feature, index, currentFrame, keyframeInterval }) {
    const classes = useFeatureStyles();
    const animationClasses = useAnimationStyles();
    // offsetting the currentFrame by keyframeInterval
    // to account for the first 4 frames with no area feature animation
    const animatedState = (currentFrame - keyframeInterval) > ((index + 1) * keyframeInterval);
    const { category, distance, name } = feature || {};
    const label = FEATURE_CONFIG[category]
        ? FEATURE_CONFIG[category].label || null
        : null;
    const formattedDistance = formatDistance(distance) || null;
    if(!category) return null;
    return (
        <div className={`${classes.featureBlock} ${classes['featurePosition' + (index+1)]}`}>
            <div className={classes.relativeDiv}>
                <div className={`${classes.iconBubble} ${animatedState ? animationClasses.iconBubble : ''}`}>
                    <div className={`${classes.icon} ${animatedState ? animationClasses.icon : ''}`}>
                        <AreaIcon index={index}
                            animatedState={animatedState}
                            category={category}
                            placeName={name}
                        />
                    </div>
                </div>

                {!!formattedDistance && (<div className={classes.distance}>
                    {formattedDistance} mile{`${(formattedDistance === '1') ? '' : 's'}`}
                </div>)}

                {(label && label.length > 0) && (<div className={classes.label}>
                    {label}
                </div>)}
            </div>
        </div>
    );
}

export default AreaFeature;
